<div class="addresses-list grid mobile:grid-cols-1  tablet:grid-cols-2 grid-cols-2 gap-4">

    <ng-container *ngFor="let address of userDetails.addresses,let i=index;">
        <div  *ngIf="address" class="  card address-card bg-card-new card-radius-06 border-0 p-8">
            <div class="flex flex-col w-full">
                <div class="flex flex-row justify-between">
                    <div class="w-full section-title">
                        <h4>{{address.title}}</h4>
                    </div>
                    <div *ngIf="userDetails.defaultAddress==address._id" class="default_badge">
                        <div class="default-text">{{"default_address"|translate}}</div>
                    </div>
                </div>
                    <div class="profile-row">
                        <div class="row-title">
                           <span> {{'name'|translate}}</span>
                        </div>
                        <div class="row-info">
                            <span>{{address.name}}</span>
                        </div>
                    </div>
                    <div class="profile-row">
                        <div class="row-title">
                           <span> {{'email'|translate}}</span>
                        </div>
                        <div class="row-info">
                            <span>{{userDetails.email}}</span>
                        </div>
                    </div>
                    <div class="profile-row">
                        <div class="row-title">
                           <span> {{'building'|translate}}</span>
                        </div>
                        <div class="row-info">
                            <span>{{address.building}}</span>
                        </div>
                    </div>
                    <div class="profile-row">
                        <div class="row-title">
                           <span> {{'road'|translate}}</span>
                        </div>
                        <div class="row-info">
                            <span>{{address.road}}</span>
                        </div>
                    </div>
                    <div class="profile-row">
                        <div class="row-title">
                           <span> {{'block'|translate}}</span>
                        </div>
                        <div class="row-info">
                            <span>{{address.block}} {{address.city}}</span>
                        </div>
                    </div>
                    <div class="profile-row">
                        <div class="row-title">
                           <span> {{'country'|translate}}</span>
                        </div>
                        <div class="row-info">
                            <span>{{address.country}}</span>
                        </div>
                    </div>
                        <div class="actions-row">
                            <button class="btn action save" (click)="editAddress(i,address)"><span class="mx-2">{{"edit"|translate}}</span></button>
                            <button class="btn remove action mx-2" (click)="removeAddress(i,address._id)"><span class="mx-2">{{"remove"|translate}}</span></button>
                            <button class="btn action default" [disabled]="userDetails.defaultAddress==address._id" (click)="setDefaultAddress(address._id)"><span class="mx-2">{{"default"|translate}}</span></button>
                        </div>
        </div>
        </div>
     </ng-container>

     <a routerLink="./" class="  addresses-list__item--new bg-card-new card-radius-06">
        <div class="addresses-list__plus"></div>
        <div class="btn btn-secondary btn-sm" (click)="addAddress()">{{"add_new"|translate}}</div>
    </a>
</div>
